import {toast} from "sonner";
import {hapticError} from "./haptics";

/**
 * Централизованная вибрация на ошибочные уведомления.
 *
 * ## Почему централизованно, а не на местах вызова
 *
 * `toast.error(...)` вызывается в приложении 91 раз (валидация форм, отказы
 * сети, ошибки оплаты). Расставлять `hapticError()` рядом с каждым — это 91
 * шанс забыть его в новом коде и гарантированное расхождение через месяц.
 * Оборачивая `toast.error` один раз, получаем инвариант: **любое сообщение об
 * ошибке отзывается одинаково, включая ещё не написанные**.
 *
 * ## Почему это не задевает остальные тосты
 *
 * Подменяется ровно один метод — `error`. `toast.success`, `toast.info`,
 * `toast.warning`, `toast.loading` и сам `toast(...)` остаются нетронутыми и
 * не вибрируют: успех сохранения настроек не должен ощущаться как отказ, а
 * «успех» на каждое действие обесценил бы отклик мэтча.
 */
let installed = false;

export function installToastErrorHaptics(): void {
    if (installed) return;
    installed = true;

    const target = toast as unknown as {error: (...args: unknown[]) => unknown};
    const original = target.error;
    if (typeof original !== "function") return;

    target.error = function patchedError(...args: unknown[]) {
        // Хаптик до показа: визуальное и тактильное должны совпасть по времени,
        // иначе связь «причина → отклик» разваливается.
        hapticError();
        return original.apply(toast, args);
    };
}

/** Только для тестов: вернуть возможность повторной установки. */
export function __resetToastErrorHapticsForTests(): void {
    installed = false;
}
